/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const ViewerModal = (props: any) => {
   const { t } = useTranslation("translation", { keyPrefix: "FILE_MANAGER" });


  const { setActive, activeFile, setPdfModal, pdfModal } = props;


  const [numPages, setNumPages] = React.useState<number>(0);
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };
  const goToPrevPage = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const goToNextPage = () => setCurrentPage((p) => Math.min(p + 1, numPages));

  return (
    <Fragment>
        <Modal
          isOpen={pdfModal}
          toggle={() => setPdfModal(false)}
          size="xl"
          centered
        >
          <ModalHeader toggle={() => setPdfModal(false)}>
            {activeFile?.name}
          </ModalHeader>
          <ModalBody style={{ minHeight: 600 }}>
            {activeFile?.presignedUrl && (
              <div style={{ textAlign: "center" }}>
                <Document
                  file={activeFile.presignedUrl}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  <Page pageNumber={currentPage} width={900} />
                </Document>
                <div
                  style={{
                    marginTop: 24,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 16,
                  }}
                >
                  <button
                    className="btn btn-outline-secondary"
                    onClick={goToPrevPage}
                    disabled={currentPage <= 1}
                  >
                    &lt; {t("FILE:PREV") || "Precedente"}
                  </button>
                  <span>
                    {currentPage} / {numPages}
                  </span>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={goToNextPage}
                    disabled={currentPage >= numPages}
                  >
                    {t("FILE:NEXT") || "Successiva"} &gt;
                  </button>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
    </Fragment>
  );
};

export default ViewerModal;
